import { render, staticRenderFns } from "./ModalUnitCount.vue?vue&type=template&id=264b545c&scoped=true&lang=pug&"
import script from "./ModalUnitCount.vue?vue&type=script&lang=ts&"
export * from "./ModalUnitCount.vue?vue&type=script&lang=ts&"
import style0 from "./ModalUnitCount.vue?vue&type=style&index=0&id=264b545c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b545c",
  null
  
)

export default component.exports